import styled from "styled-components"
import {ContainerGrid} from "shared" 
export const ContactContainer = styled(ContainerGrid).attrs({})`
    &&{
        margin-top: 60px;
    }
`
